const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/ideas/view/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/idea-management/ideas/view/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {},
    collapseLeftNav: true
  }
});